import React from 'react';
import { Link } from 'react-router-dom';
import PartnersStrip from '../components/PartnersStrip';
// import PhotoBanner from '../components/PhotoBanner'; // Removed - photos now in /gallery
import { useTranslation } from '../hooks/useTranslation';
import SEO, { PageSEO } from '../components/SEO';
import ImpactStoriesTicker from '../components/ImpactStoriesTicker';
// import NewYearBanner from '../components/NewYearBanner'; // Removed - New Year 2026 banner disabled

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <SEO {...PageSEO.home} url="/" />
      
      {/* Happy New Year 2026 Banner - DISABLED */}
      {/* <NewYearBanner /> */}
      
      {/* Hero Section - Updated for Makona River Region */}
      <section className="relative bg-gradient-to-br from-kioo-primary via-kioo-secondary to-kioo-dark text-white py-12 sm:py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        
        {/* Radio waves background animation */}
        <div className="absolute top-10 right-10 opacity-10">
          <div className="radio-waves">
            <div className="w-32 h-32 border-4 border-white rounded-full"></div>
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            
            {/* Hero Content - Updated Text */}
            <div className="hero-content hero-fade-in">
              {/* Centered Main Title */}
              <div className="text-center mb-6 sm:mb-8">
                <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                  {t('home.heroTitle')}
                </h1>
                
                <p className="text-base sm:text-xl lg:text-2xl mb-6 sm:mb-8 text-green-100 leading-relaxed max-w-3xl mx-auto">
                  {t('home.heroSub')}
                </p>
              </div>

              {/* CTA grid: 2×2 on mobile, single row on desktop */}
              <div className="grid grid-cols-2 sm:flex sm:flex-row gap-3 sm:gap-4 mb-8 sm:justify-center max-w-md sm:max-w-none mx-auto">
                <Link 
                  to="/listen-live"
                  data-testid="home-cta-listen-live"
                  className="btn-primary inline-flex items-center justify-center space-x-2 sm:space-x-3 text-sm sm:text-lg col-span-2 sm:col-span-1"
                >
                  <span className="w-3 h-3 bg-red-400 rounded-full live-pulse"></span>
                  <span>{t('home.listenLive')}</span>
                </Link>
                
                <Link 
                  to="/programs"
                  data-testid="home-cta-programs"
                  className="px-4 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg font-semibold text-sm sm:text-base hover:bg-white hover:text-kioo-primary transition-all duration-200 text-center"
                >
                  <span>{t('home.programs')}</span>
                </Link>

                <Link 
                  to="/church-partners"
                  data-testid="home-cta-church-partners"
                  className="px-4 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg font-semibold text-sm sm:text-base hover:bg-white hover:text-kioo-primary transition-all duration-200 text-center"
                >
                  <span>⛪ {t('nav.churchPartners')}</span>
                </Link>

                <Link 
                  to="/donate"
                  data-testid="home-cta-donate"
                  className="px-4 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg font-semibold text-sm sm:text-base hover:bg-white hover:text-kioo-primary transition-all duration-200 text-center"
                >
                  <span>{t('home.donate')}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Stories News Flash (hides if no stories published) */}
      <ImpactStoriesTicker />


      {/* Partners Strip - Above Footer */}
      <PartnersStrip />
    </div>
  );
};

export default Home;